module.exports = __webpack_public_path__ + "static/img/180.5ae3f5e3.png";